import { render, staticRenderFns } from "./intro_footer.vue?vue&type=template&id=00ec3194&scoped=true&"
import script from "./intro_footer.vue?vue&type=script&lang=js&"
export * from "./intro_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ec3194",
  null
  
)

export default component.exports